import { render, staticRenderFns } from "./RuleType1.vue?vue&type=template&id=7a87abab&scoped=true"
import script from "./RuleType1.vue?vue&type=script&lang=js"
export * from "./RuleType1.vue?vue&type=script&lang=js"
import style0 from "./RuleType1.vue?vue&type=style&index=0&id=7a87abab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a87abab",
  null
  
)

export default component.exports